import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import axios from "axios";
import "./OffersSlider.css";
import { Container } from "react-bootstrap";
import { BASE_URL } from "../../config";

const OffersSlider = () => {
  const [slides, setOffers] = useState([]);
  const [activeTab, setActiveTab] = useState("All");

  const tabs = ["All", "Flight", "Hotel", "Holiday"];

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await axios.get(`${BASE_URL}AllOffers`);
        if (res.data?.success && Array.isArray(res.data.data)) {
          setOffers(res.data.data);
        }
      } catch (error) {
        console.error("Offers API Error:", error);
      }
    };

    fetchOffers();
  }, []);

  /* ✅ FILTER LOGIC PERFECT */
  const filteredOffers =
    activeTab === "All"
      ? slides
      : slides.filter(
          (item) =>
            item.offer_type &&
            item.offer_type
              .toLowerCase()
              .trim()
              .includes(activeTab.toLowerCase())
        );

  return (
    <section className="offers-wrap">
      <Container>

        {/* TITLE */}
        <div className="offers-title">
          <h2>
            Best <span>Deals & Offers</span> for You
          </h2>
        </div>

        {/* TABS */}
        <div className="offers-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`offers-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* SLIDER */}
        {filteredOffers.length > 0 ? (
          <Swiper
            key={activeTab}                 /* 🔥 MOST IMPORTANT FIX */
            modules={[Autoplay]}
            slidesPerView="auto"
            spaceBetween={20}
            loop={filteredOffers.length > 2}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            className="offers-swiper"
          >
            {filteredOffers.map((slide) => (
              <SwiperSlide key={slide.id || slide._id}>
                <div className="offer-slide">
                  <img src={slide.image} alt={slide.name} />

                  {slide.offer_type && (
                    <span className="offer-type">
                      {slide.offer_type}
                    </span>
                  )}

                  <div className="offer-content">
                    <h4>{slide.name}</h4>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            No offers found for <b>{activeTab}</b>
          </p>
        )}

      </Container>
    </section>
  );
};

export default OffersSlider;
